<!-- 导航菜单组件 -->
<script lang="ts" setup>
import { useAuthStore } from '~/stores/authStore'
import NavigationMenuFold from '~/assets/icons/app/navigationMenuFold.svg?component'
import NavigationMenuUnfold from '~/assets/icons/app/navigationMenuUnfold.svg?component'
import NavigationMenuHome from '~/assets/icons/app/NavigationMenuHome.png'
import NavigationMenuHomeActivation from '~/assets/icons/app/NavigationMenuHome_Activation.png'
import NavigationMenuGenerate from '~/assets/icons/app/NavigationMenuGenerate.png'
import NavigationMenuGenerateActivation from '~/assets/icons/app/NavigationMenuGenerate_Activation.png'
import NavigationMenuStemSeparation from '~/assets/icons/app/NavigationMenuStemSeparation.png'
import NavigationMenuStemSeparationActivation from '~/assets/icons/app/NavigationMenuStemSeparation_Activation.png'
import NavigationMenuLibrary from '~/assets/icons/app/NavigationMenuLibrary.png'
import NavigationMenuLibraryActivation from '~/assets/icons/app/NavigationMenuLibrary_Activation.png'
import NavigationMenuNotification from '~/assets/icons/app/NavigationMenuNotification.png'
import NavigationMenuNotificationActivation from '~/assets/icons/app/NavigationMenuNotification_Activation.png'
import NavigationMenuEarnCredits from '~/assets/icons/app/navigationMenuEarnCredits.svg?component'
import NavigationMenuSignin from '~/assets/icons/app/navigationMenuSigninWeb.png'
import NavigationMenuSignup from '~/assets/icons/app/NavigationMenuSignup.png'
import NavigationMenuProfile from '~/assets/icons/app/NavigationMenuProfile.png'
import NavigationMenuSubscription from '~/assets/icons/app/NavigationMenuSubscription.png'
import NavigationMenuLogOut from '~/assets/icons/app/navigationMenuLogOut.svg?component'
import Help from '~/assets/icons/app/help.svg?component'

interface menuItemType {
  label: string
  icon: string
  activaIcon: string
  to: string
  show: boolean
}

const route = useRoute()
const menuItems = ref<menuItemType[]>([{
  label: 'Home',
  icon: NavigationMenuHome,
  activaIcon: NavigationMenuHomeActivation,
  to: '/',
  show: true
}, {
  label: 'Generate',
  icon: NavigationMenuGenerate,
  activaIcon: NavigationMenuGenerateActivation,
  to: '/generate',
  show: true
},
// {
//   label: 'Stem Separation',
//   icon: NavigationMenuStemSeparation,
//   activaIcon: NavigationMenuStemSeparationActivation,
//   to: '/stemSeparation',
//   show: true
// },
{
  label: 'Library',
  icon: NavigationMenuLibrary,
  activaIcon: NavigationMenuLibraryActivation,
  to: '/library/mySongs',
  show: true
}, {
  label: 'Notification',
  icon: NavigationMenuNotification,
  activaIcon: NavigationMenuNotificationActivation,
  to: '/notification',
  show: false
}])
const activeLabel = computed(() => {
  const current = menuItems.value.find(i => i.to === route.path)
  return current?.label ?? ''
})

const loginStore = useLoginStore()
const authStore = useAuthStore()

const isLogin = computed(() => authStore.isAuthenticated)
const userDisplayName = computed(() => authStore.displayName)
const userCredits = computed(() => authStore.credits)
const formattedCredits = computed(() => userCredits.value.toLocaleString('en-US'))
const isUltraPlanYear = computed(() => authStore.user?.subscribe === 'Ultra Plan-Year')
const navbarStatus = ref<'unfold' | 'fold'>('unfold')
const toggleNavbarStatus = () => {
  navbarStatus.value = navbarStatus.value === 'unfold' ? 'fold' : 'unfold'
}

const myProfileStore = useMyProfileStore()
const inviteModalStore = useInviteModalStore()
const notificationStore = useNotificationStore()
const handleLogout = () => {
  authStore.logout()
}

// 获取未读通知数量
const unreadNotificationCount = computed(() => notificationStore.unreadCount)

// 添加打开帮助页面的函数
const openHelp = () => {
  window.open('https://xmusio.tawk.help/', '_blank', 'noopener')
}
</script>

<template>
  <div :class="`flex flex-col justify-between navigation-menu-container ${navbarStatus === 'unfold' ? 'w-[200px]' : 'w-[60px]'} h-full font-['Roboto'] py-[32px] transition-all duration-300 ease-in-out overflow-y-auto`">
    <div>
      <div class="relative flex items-center justify-center h-[74px]">
        <p
          v-show="navbarStatus === 'unfold'"
          class="text-[30px] text-[#D9D9D9] font-bold leading-[40px]"
        >
          XMUSIO
        </p>
        <div
          :class="`absolute ${navbarStatus === 'unfold' ? 'right-[10px]' : 'right-[18px]'} w-[24px] h-[24px] text-[#B8B8C7] cursor-pointer`"
          @click="toggleNavbarStatus()"
        >
          <NavigationMenuFold
            v-if="navbarStatus === 'unfold'"
            class="w-full h-full"
          />
          <NavigationMenuUnfold
            v-else
            class="w-full h-full"
          />
        </div>
      </div>
      <div class="py-[23px]">
        <div class="flex flex-col">
          <div
            v-for="(menuItem, index) in menuItems"
            :key="index"
          >
            <NuxtLink
              v-if="menuItem.show && (isLogin || menuItem.to === '/')"
              :to="menuItem.to"
            >
              <div
                :class="`flex items-center gap-[4px] ${navbarStatus === 'unfold' ? 'pl-[32px]' : 'pl-[18px]'} py-[9px] hover:bg-[#383847]`"
              >
                <img
                  v-if="activeLabel === menuItem.label"
                  class="size-[24px]"
                  :src="menuItem.activaIcon"
                  alt=""
                >
                <img
                  v-else
                  class="size-[24px]"
                  :src="menuItem.icon"
                  alt=""
                >
                <p
                  v-show="navbarStatus === 'unfold'"
                  :class="`text-[16px] ${activeLabel === menuItem.label ? 'text-[#BF2AFF]' : 'text-[#8888A1]'} text-nowrap`"
                >
                  {{ menuItem.label }}
                </p>
              </div>
            </NuxtLink>
            <div
              v-else-if="menuItem.show && !isLogin && menuItem.to !== '/'"
              :class="`flex items-center gap-[4px] ${navbarStatus === 'unfold' ? 'pl-[32px]' : 'pl-[18px]'} py-[9px] hover:bg-[#383847] cursor-pointer`"
              @click="loginStore.openLoginModal('SignIn')"
            >
              <img
                v-if="activeLabel === menuItem.label"
                class="size-[24px]"
                :src="menuItem.activaIcon"
                alt=""
              >
              <img
                v-else
                class="size-[24px]"
                :src="menuItem.icon"
                alt=""
              >
              <p
                v-show="navbarStatus === 'unfold'"
                :class="`text-[16px] ${activeLabel === menuItem.label ? 'text-[#BF2AFF]' : 'text-[#8888A1]'}`"
              >
                {{ menuItem.label }}
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="my-[13px]">
        <p :class="`text-[16px] text-[#85859F] leading-[24px] py-[9px] ${navbarStatus === 'unfold' ? 'px-[32px]' : 'px-[18px]'} hover:bg-[#383847] cursor-pointer`">
          API
        </p>
      </div> -->
        <div class="w-[26px] h-[1px] bg-[#383847] mx-auto" />
        <div class="flex flex-col mt-[23px]">
          <!-- 登录状态的展示 -->
          <div v-if="isLogin">
            <NuxtLink to="/subscribe">
              <div :class="`${navbarStatus === 'unfold' ? 'p-[8px] mx-[32px]' : ''}`">
                <p class="text-[14px] text-[#D880FF] text-center leading-[20px]">
                  {{ formattedCredits }}
                </p>
                <p class="text-[12px] text-[#85859F] text-center leading-[16px]">
                  Credits
                </p>
                <div
                  v-show="navbarStatus === 'unfold' && !isUltraPlanYear"
                  class="w-full text-[12px] text-[#D880FF] bg-[#BF2AFF33] px-[38px] py-[8px] rounded-[8px] mt-[16px] cursor-pointer"
                >
                  Upgrade
                </div>
              </div>
            </NuxtLink>
            <UPopover
              :key="authStore.avatarUrl"
              mode="click"
              :content="{ side: 'right', align: 'start', sideOffset: -6 }"
              :ui="{
                content: 'bg-[#383847] border border-[#5E5E77] rounded-[8px] ring-0'
              }"
            >
              <div :class="`flex items-center ${navbarStatus === 'unfold' ? 'px-[32px] mt-[20px]' : 'justify-center mt-[4px]'} py-[12px] hover:bg-[#383847] cursor-pointer`">
                <div class="w-[40px] h-[40px] rounded-full">
                  <UAvatar
                    v-if="authStore.avatarUrl"
                    :src="authStore.avatarUrl"
                    :ui="{
                      root: 'w-full h-full',
                      image: 'w-full h-full'
                    }"
                  />
                  <img
                    v-else
                    class="w-[40px] h-[40px] rounded-full"
                    src="https://copyright.bdstatic.com/vcg/creative/d90a05ca26b2ca79dc1cbaa4931b18ee.jpg@wm_1,k_cGljX2JqaHdhdGVyLmpwZw=="
                  >
                </div>
                <p
                  v-show="navbarStatus === 'unfold'"
                  class="flex-1 text-[16px] text-[#8888A1] ml-[8px] truncate"
                >
                  {{ userDisplayName }}
                </p>
              </div>
              <template #content>
                <div
                  class="flex items-center gap-x-[8px] px-[12px] py-[6px] hover:bg-[#262635] cursor-pointer rounded-t-[8px]"
                  @click="myProfileStore.openMyProfileModal()"
                >
                  <img
                    class="size-[16px]"
                    :src="NavigationMenuProfile"
                    alt=""
                  >
                  <p class="text-[14px] text-[#E7E7EC] leading-[20px]">
                    My Profile
                  </p>
                </div>
                <NuxtLink to="/subscribe">
                  <div class="flex items-center gap-x-[8px] px-[12px] py-[6px] hover:bg-[#262635] cursor-pointer">
                    <img
                      class="size-[16px]"
                      :src="NavigationMenuSubscription"
                      alt=""
                    >
                    <p class="text-[14px] text-[#E7E7EC] leading/[20px]">
                      Manage Subscription
                    </p>
                  </div>
                </NuxtLink>
                <div
                  class="flex items-center gap-x-[8px] px-[12px] py-[6px] hover:bg-[#262635] cursor-pointer rounded-b-[8px]"
                  @click="handleLogout"
                >
                  <NavigationMenuLogOut class="size-[16px] text-[#E7E7EC]" />
                  <p class="text-[14px] text-[#E7E7EC] leading-[20px]">
                    Log Out
                  </p>
                </div>
              </template>
            </UPopover>
            <NuxtLink to="/notification">
              <div :class="`flex items-center ${navbarStatus === 'unfold' ? ' px-[32px]' : 'justify-center'} py-[12px] hover:bg-[#383847] cursor-pointer`">
                <!-- 图标 + 角标容器 -->
                <div class="relative size-[24px]">
                  <img
                    v-if="activeLabel === 'Notification'"
                    class="size-[24px]"
                    :src="NavigationMenuNotificationActivation"
                    alt=""
                  >
                  <img
                    v-else
                    class="size-[24px]"
                    :src="NavigationMenuNotification"
                    alt=""
                  >
                  <!-- 红色数字角标 -->
                  <span
                    v-if="unreadNotificationCount > 0"
                    class="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-[4px] text-[10px] text-white text-center leading-[16px] bg-[#B3261E] rounded-full flex items-center justify-center"
                    :class="unreadNotificationCount > 9 ? 'px-[2px]' : ''"
                  >
                    {{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}
                  </span>
                </div>
                <p
                  v-show="navbarStatus === 'unfold'"
                  :class="`flex-1 text-[16px] ${activeLabel === 'Notification' ? 'text-[#BF2AFF]' : 'text-[#85859F]'} ml-[4px] truncate`"
                >
                  Notification
                </p>
              </div>
            </NuxtLink>
            <!-- <div
              :class="`flex items-center ${navbarStatus === 'unfold' ? ' px-[32px]' : 'justify-center'} py-[12px] hover:bg-[#383847] cursor-pointer`"
              @click="inviteModalStore.openInviteModal()"
            >
              <NavigationMenuEarnCredits class="size-[24px] text-[#85859F]" />
              <p
                v-show="navbarStatus === 'unfold'"
                class="flex-1 text-[16px] text-[#8888A1] ml-[4px] truncate"
              >
                Earn Credits
              </p>
            </div> -->
          </div>
          <!-- 非登录状态的展示 -->
          <div v-else>
            <div
              :class="`flex items-center ${navbarStatus === 'unfold' ? 'px-[32px]' : 'px-[18px]'} py-[9px] hover:bg-[#383847] cursor-pointer`"
              @click="loginStore.openLoginModal('SignIn')"
            >
              <div class="size-[24px] bg-[#E7E7EC] rounded-[4px]">
                <img
                  class="size-[24px] p-[4px]"
                  :src="NavigationMenuSignin"
                  alt=""
                >
              </div>
              <p
                v-show="navbarStatus === 'unfold'"
                class="flex-1 text-[16px] text-[#E7E7EC] ml-[16px] truncate"
              >
                Sign in
              </p>
            </div>
            <div
              :class="`flex items-center ${navbarStatus === 'unfold' ? 'px-[32px]' : 'px-[18px]'} py-[9px] hover:bg-[#383847] cursor-pointer`"
              @click="loginStore.openLoginModal('SignUpVerifyCode')"
            >
              <div class="flex items-center justify-center size-[24px] bg-[#E7E7EC] rounded-[4px]">
                <img
                  class="size-[24px] p-[4px]"
                  :src="NavigationMenuSignup"
                  alt=""
                >
              </div>
              <p
                v-show="navbarStatus === 'unfold'"
                class="flex-1 text-[16px] text-[#E7E7EC] ml-[16px] truncate"
              >
                Sign up
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex items-center justify-center gap-x-[4px] cursor-pointer"
      @click="openHelp"
    >
      <Help class="size-[24px] text-[#8888A1]" />
      <p
        v-if="navbarStatus === 'unfold'"
        class="text-[16px] text-[#8888A1] leading-[20px]"
      >
        Help
      </p>
    </div>
  </div>
</template>
